// =============================================================================
//          (c) Copyright 2021 by Brinks Home Security | Dallas, TX, USA
// =============================================================================
// Version   : 0.1.1
// Created at: 12.13.16
// Project   : Brinks Home Security Shared Assets
// -----------------------------------------------------------------------------
// Custom settings and validations for jQuery.validate
// -----------------------------------------------------------------------------

const ValidateCustom = (($) => {
  const Class = {
    FORM_DANGER: 'has-danger',
    INPUT_DANGER: 'form-control-danger'
  }

  const Selector = {
    FORM_GROUP: '.form-group',
    RADIO_CHECKBOX: 'input[type=checkbox], input[type=radio]'
  }

  // Configure jquery.validate for BS4
  $.validator.setDefaults({
    highlight: (element) => {
      $(element).closest(Selector.FORM_GROUP).addClass(Class.FORM_DANGER)
      $(element).addClass(Class.INPUT_DANGER)
    },
    unhighlight: (element) => {
      $(element).closest(Selector.FORM_GROUP).removeClass(Class.FORM_DANGER)
      $(element).removeClass(Class.INPUT_DANGER)
    },
    errorElement: 'small',
    errorClass: 'form-control-feedback',
    errorPlacement: (error, element) => {
      if (element.closest(Selector.FORM_GROUP).find(Selector.RADIO_CHECKBOX).length > 1) {
        error.insertAfter(element.closest(Selector.FORM_GROUP))
      } else {
        error.insertAfter(element)
      }
    },
    onkeyup: false
  })

  // Override email validation method to require a top-level domain.
  // i.e. 'bob@livewatch' is NOT valid, while 'bob@livewatch.com' is
  // This is fairly permissive, just requiring {anything}@{anything}.{anything}
  // the point is not to exhaustively validate all possible email addresses,
  // but to catch mistakes that a user might reasonably make
  $.validator.methods.email = function (value, element) {
    return this.optional(element) || /^.+@.+\..+$/.test(value)
  }

  // Add custom zipcode validation method
  $.validator.addMethod('zipcode-custom', function (value, element) {
    return this.optional(element) || /(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$)/.test(value)
  }, 'Please provide a valid zipcode.')

  // Add custom phone validation
  $.validator.addMethod('phone-custom', function (value, element) {
    return this.optional(element) || /^\(\d{3}\) \d{3}-\d{4}$|^\d{10}$/.test(value)
  }, 'Please provide a valid phone number.')
})(jQuery)

export default ValidateCustom
